import { render, staticRenderFns } from "./DrzavaDetails.vue?vue&type=template&id=41155d19&scoped=true&"
import script from "./DrzavaDetails.vue?vue&type=script&lang=js&"
export * from "./DrzavaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41155d19",
  null
  
)

export default component.exports